import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import Link from "next/link";
import LogoArea from "./Logo.style";
import Image from "next/image";
export const Logo = (param)=>{
    let { className , withLink , title , src , linkTo ="#" , size  } = param;
    return /*#__PURE__*/ _jsx(LogoArea, {
        className: className,
        children: withLink ? /*#__PURE__*/ _jsx(Link, {
            href: linkTo,
            passHref: true,
            legacyBehavior: true,
            children: src ? /*#__PURE__*/ _jsx(Image, {
                src: src,
                alt: title,
                ...size
            }) : /*#__PURE__*/ _jsx("h3", {
                children: title
            })
        }) : /*#__PURE__*/ _jsx(_Fragment, {
            children: /*#__PURE__*/ _jsx("a", {
                children: src ? /*#__PURE__*/ _jsx(Image, {
                    src: src,
                    alt: title,
                    ...size
                }) : /*#__PURE__*/ _jsx("h3", {
                    children: title
                })
            })
        })
    });
};
